import { useQuery } from 'react-query'
import { BASE_API_URL } from 'constants/env'
import { API_METHODS } from 'constants/api-methods'
import { apiHeaders } from 'utils/api-headers'
import { store } from 'index'
import { handleErrors } from 'utils/handle-errors'

const fetchChatMessages = async (chatId: string) => {
  let response = await fetch(`${BASE_API_URL}/admin/api/v2/chats/${chatId}`, {
    method: API_METHODS.GET,
    headers: apiHeaders(store.getState()),
  })
  response = handleErrors(response)
  return response.json()
}

const useChatMessages = (chatId: string) => {
  return useQuery(
    ['chats', chatId, 'messages'],
    () => fetchChatMessages(chatId),
    {
      enabled: !!chatId,
    }
  )
}

export default useChatMessages
